// extracted by mini-css-extract-plugin
export default {"FeaturedAdmin":"FeaturedAdmin_FeaturedAdmin__UILpp"};